<template>
  <div :class="isPc ? 'signup' : ''">
    <IconSwitch :type="'qrcode'"></IconSwitch>
    <Icon></Icon>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Inputs :type="'account'" v-on:inputText="getAccount" v-on:enterInput="enterInput"></Inputs>
    <el-collapse-transition>
      <Warn :type="'accountexist'" :data="account" v-if="exist"></Warn>
    </el-collapse-transition>
    <Buttons ref=btn :type="'continue'" :data="account" v-on:accountExist="accountExist" v-on:openErrorTip="openErrorTip"></Buttons>
    <Foot :type="'Already using crait'" style="margin-bottom: 44px;"></Foot>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Error from '../components/Error'
  import Inputs from '../components/Inputs'
  import Warn from '../components/Warn'
  import Buttons from '../components/Buttons'
  import Foot from '../components/Foot'
  import { errorFn } from '../common/ErrorMsg.js'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        account: '', // 输入的账号
        exist: false
      }
    },
    components: {
      IconSwitch, Icon, Error, Inputs, Warn, Buttons, Foot
    },
    props: ['isPc'],
    mounted () {
    },
    methods: {
      getAccount (data) {
        this.account = data
        this.exist = false
      },
      accountExist () {
        this.errorShow = false
        this.exist = true
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../assets/css/_mixin.scss';
  .signup {
    @include white-bg;
    min-height: 420px;
    margin-top: -210px;
  }
</style>



// WEBPACK FOOTER //
// Signup.vue?c82f2e30